// src/components/analytics/AIRecommendations.js
import React from 'react';
import { 
  Box, Paper, Typography, Card, CardContent, 
  List, ListItem, ListItemIcon, ListItemText,
  Chip, Alert, Button 
} from '@mui/material';
import { 
  Psychology, CheckCircle, Warning, 
  TrendingUp, Lightbulb, Download 
} from '@mui/icons-material';

const AIRecommendations = ({ analysis, showDetailed = false, t }) => {
  const getPriorityColor = (index) => {
    if (index === 0) return 'error';
    if (index === 1) return 'warning';
    return 'info';
  };

  const getPriorityLabel = (index) => {
    if (index === 0) return t('analytics_priority_high');
    if (index === 1) return t('analytics_priority_medium');
    return t('analytics_priority_low');
  };

  return (
    <Paper sx={{ p: 3, height: showDetailed ? 'auto' : 400 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <Psychology color="primary" />
        <Typography variant="h6">
          {t('analytics_ai_recommendations')}
        </Typography>
      </Box>

      {/* Список рекомендацій */}
      <List dense={!showDetailed}>
        {analysis.recommendations.map((recommendation, index) => (
          <ListItem key={index} sx={{ mb: 1 }}>
            <ListItemIcon>
              {index === 0 ? (
                <Warning color="error" />
              ) : index === 1 ? (
                <TrendingUp color="warning" />
              ) : (
                <Lightbulb color="info" />
              )}
            </ListItemIcon>
            <ListItemText
              primary={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="body1">
                    {t(recommendation)}
                  </Typography>
                  <Chip 
                    label={getPriorityLabel(index)}
                    size="small"
                    color={getPriorityColor(index)}
                    variant="outlined"
                  />
                </Box>
              }
              secondary={showDetailed && t(`${recommendation}_details`)}
            />
          </ListItem>
        ))}
      </List>

      {analysis.recommendations.length === 0 && (
        <Alert severity="success" icon={<CheckCircle />}>
          {t('analytics_all_targets_met')}
        </Alert>
      )}

      {showDetailed && (
        <Box sx={{ mt: 3, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
          <Typography variant="body2" gutterBottom>
            <strong>{t('analytics_implementation_timeline')}</strong>
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {t('analytics_recommendations_timeline')}
          </Typography>
          
          <Button 
            variant="outlined" 
            startIcon={<Download />}
            size="small"
          >
            {t('analytics_download_action_plan')}
          </Button>
        </Box>
      )}
    </Paper>
  );
};

export default AIRecommendations;